(function(window, angular){'use strict';

var ngModule = angular.module('pp.components.required-any', []);

/**
 * @ngdoc directive
 * @name requiredAny
 * @description
 * Sets the field invalid if both of the fields with the same parameter value on the directive ppRequiredAny are empty
 *
 * @restrict A
 * @scope
 */
ngModule.directive('ppRequiredAny', function () {
    // Hash for holding the state of each group
    var groups = {};

    // Helper function: Determines if at least one control
    //                  in the group is non-empty
    function determineIfRequired(groupName) {
        var group = groups[groupName];
        if (!group) {
            return false;
        }
        var keys = Object.keys(group);
        return keys.every(function (key) {
            return (key === 'isRequired') || !group[key];
        });
    }

    return {
        restrict: 'A',
        require: '?ngModel',
        scope: {
            isDisabled: '<'
        }, // an isolate $scope is used for easier/cleaner
        // $watching and cleanup (on destruction)
        link: function postLink($scope, elem, attrs, ctrl) {

            // If there is no `ngModel` or no groupName has been specified or input is readonly,
            // then there is nothing we can do
            if (!ctrl || !attrs.ppRequiredAny || $scope.isDisabled) {
                return;
            }

            // Get a hold on the group's state object
            // (if it doesn't exist, initialize it first)
            var groupName = attrs.ppRequiredAny;
            if (groups[groupName] === undefined) {
                groups[groupName] = {
                    isRequired: true
                };
            }
            var group = $scope.group = groups[groupName];

            // Clean up when the element is removed
            $scope.$on('$destroy', function () {
                delete(group[$scope.$id]);
                if (Object.keys(group).length <= 1) {
                    delete(groups[groupName]);
                }
            });

            // Updates the validity state for the 'required' error-key
            // based on the group's status
            function updateValidity() {
                if (group.isRequired) {
                    ctrl.$setValidity('required', false);
                } else {
                    ctrl.$setValidity('required', true);
                }
            }

            // Updates the group's state and this control's validity
            function validate(value) {
                group[$scope.$id] = !ctrl.$isEmpty(value);
                group.isRequired = determineIfRequired(groupName);
                updateValidity();
                return group.isRequired ? undefined : value;
            }

            // Make sure re-validation takes place whenever:
            //   either the control's value changes
            //   or the group's `isRequired` property changes
            ctrl.$formatters.push(validate);
            ctrl.$parsers.unshift(validate);
            $scope.$watch('group.isRequired', updateValidity);
        }
    };
});
})(window, window.angular);